import { ErrorBoundary } from "@sentry/react"
import { createFileRoute } from "@tanstack/react-router"
import { useEffect, useState } from "react"

function UseEffectError() {
  useEffect(() => {
    throw new Error("Sentry useEffect test error")
  }, [])

  return <div>sentry test</div>
}

function SentryTest() {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <div>
      <div>
        <button onClick={() => setIsVisible(true)}>useEffect error</button>

        <button
          onClick={() => {
            throw new Error("Sentry onClick test error")
          }}
        >
          onClick error
        </button>
      </div>

      <ErrorBoundary fallback={<>sentry error happened</>}>{isVisible && <UseEffectError />}</ErrorBoundary>
    </div>
  )
}

export const Route = createFileRoute("/$sessionId/_session/__test/sentry")({
  component: SentryTest,
})
